import { ConversationDirection, MessageKind } from './LivechatMessageModel';

export const LiveChatChannels = {
  sms: 'SMS',
  facebook: 'Facebook Messenger',
  webchat: 'Webchat',
  instagram: 'Instagram',
  email: 'Email',
};
export type LiveChatChannel = keyof typeof LiveChatChannels;

export type LiveChatInboxStatus = 'main' | 'done' | 'pending' | 'resolved';

export type LivechatConversationModel = {
  conversationId: string | undefined;
  conversationSessionId: number | undefined;
  remoteUserId: string;
  remotePageId?: string;
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  profilePic: string | undefined;
  time: string | undefined; // Timestamp is string if defined
  direction: ConversationDirection;
  kind: MessageKind | undefined;
  structure: string;
  currentPageId?: string;
  mutedTill?: string | null; // Timestamp is string if defined
  muted?: boolean;
  inboxStatus?: LiveChatInboxStatus;
  assignedUserId?: string;
  userAssignedBy?: string;
  userAssignedAt?: string;
  followUp?: boolean;
  liveChatResponse?: boolean;
  pageBeginning?: boolean;
  linkedContacts?: {
    remoteUserId: string;
    firstName: string;
    lastName: string;
    username: string;
    structure: string;
    profilePic: string;
    time: string;
    currentPageId?: string;
    mutedTill?: string | null; // Timestamp is string if defined
    muted?: boolean;
  }[];
  preferredName?: string;
};
